/**
 * Connectivity RPC Definitions
 */

import { Rpc, RpcGroup } from "effect/rpc";
import { Schema } from "effect";
import { ConnectionStatusSchema } from "../schemas/frontdesk/connectivity/connection-status.schema";
import { ExternalAPIErrorSchema, NotFoundErrorSchema } from "../errors";

const EmptyRequest = Schema.Struct({});

export class ConnectivityRpcs extends RpcGroup.make(
  Rpc.make("ConnectivityStatus", {
    success: ConnectionStatusSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: EmptyRequest,
  })
) {}
